const states = [
    { key: 'Alabama', text: 'Alabama', value: 'AL' },
    { key: 'Alaska', text: 'Alaska', value: 'AK' },
    { key: 'Arizona', text: 'Arizona', value: 'AZ' },
    { key: 'Arkansas', text: 'Arkansas', value: 'AR' },
    { key: 'California', text: 'California', value: 'CA' },
    { key: 'Colorado', text: 'Colorado', value: 'CO' },
    { key: 'Connecticut', text: 'Connecticut', value: 'CT' },
    { key: 'Delaware', text: 'Delaware', value: 'DE' },
    { key: 'District of Columbia', text: 'District of Columbia', value: 'DC' },
    { key: 'Florida', text: 'Florida', value: 'FL' },
    { key: 'Georgia', text: 'Georgia', value: 'GA' },
    { key: 'Hawaii', text: 'Hawaii', value: 'HI' },
    { key: 'Idaho', text: 'Idaho', value: 'ID' },
    { key: 'Illinois', text: 'Illinois', value: 'IL' },
    { key: 'Indiana', text: 'Indiana', value: 'IN' },
    { key: 'Iowa', text: 'Iowa', value: 'IA' },
    { key: 'Kansas', text: 'Kansas', value: 'KS' },
    { key: 'Kentucky', text: 'Kentucky', value: 'KY' },
    { key: 'Louisiana', text: 'Louisiana', value: 'LA' },
    { key: 'Maine', text: 'Maine', value: 'ME' },
    { key: 'Maryland', text: 'Maryland', value: 'MD' },
    { key: 'Massachusetts', text: 'Massachusetts', value: 'MA' },
    { key: 'Michigan', text: 'Michigan', value: 'MI' },
    { key: 'Minnesota', text: 'Minnesota', value: 'MN' },
    { key: 'Mississippi', text: 'Mississippi', value: 'MS' },
    { key: 'Missouri', text: 'Missouri', value: 'MO' },
    { key: 'Montana', text: 'Montana', value: 'MT' },
    { key: 'Nebraska', text: 'Nebraska', value: 'NE' },
    { key: 'Nevada', text: 'Nevada', value: 'NV' },
    { key: 'New Hampshire', text: 'New Hampshire', value: 'NH' },
    { key: 'New Jersey', text: 'New Jersey', value: 'NJ' },
    { key: 'New Mexico', text: 'New Mexico', value: 'NM' },
    { key: 'New York', text: 'New York', value: 'NY' },
    { key: 'North Carolina', text: 'North Carolina', value: 'NC' },
    { key: 'North Dakota', text: 'North Dakota', value: 'ND' },
    { key: 'Ohio', text: 'Ohio', value: 'OH' },
    { key: 'Oklahoma', text: 'Oklahoma', value: 'OK' },
    { key: 'Oregon', text: 'Oregon', value: 'OR' },
    { key: 'Pennsylvania', text: 'Pennsylvania', value: 'PA' },
    { key: 'Rhode Island', text: 'Rhode Island', value: 'RI' },
    { key: 'South Carolina', text: 'South Carolina', value: 'SC' },
    { key: 'South Dakota', text: 'South Dakota', value: 'SD' },
    { key: 'Tennessee', text: 'Tennessee', value: 'TN' },
    { key: 'Texas', text: 'Texas', value: 'TX' },
    { key: 'Utah', text: 'Utah', value: 'UT' },
    { key: 'Vermont', text: 'Vermont', value: 'VT' },
    { key: 'Virginia', text: 'Virginia', value: 'VA' },
    { key: 'Washington', text: 'Washington', value: 'WA' },
    { key: 'West Virginia', text: 'West Virginia', value: 'WV' },
    { key: 'Wisconsin', text: 'Wisconsin', value: 'WI' },
    { key: 'Wyoming', text: 'Wyoming', value: 'WY' },
  ]

  export default states;